import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, LogOut } from "lucide-react";
import { authLogout } from "../lib/api";

// Coach-only sign out. Uses the EXISTING coach Google-auth logout endpoint
// (/api/auth/logout clears the `session_token` cookie + deletes the session).
export default function CoachLogoutButton() {
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);

  const signOut = async () => {
    if (busy) return;
    setBusy(true);
    try { await authLogout(); } catch (_e) { /* cookie may already be gone */ }
    navigate("/coach-login", { replace: true });
  };

  return (
    <button
      type="button"
      onClick={signOut}
      disabled={busy}
      className="btn-ghost border border-brand-border rounded-full px-4 py-2 text-xs uppercase tracking-[0.2em] font-bold text-brand-ink-muted hover:text-brand-ink inline-flex items-center gap-2 disabled:opacity-60"
      data-testid="coach-logout-btn"
    >
      {busy ? <Loader2 size={14} strokeWidth={2} className="animate-spin" /> : <LogOut size={14} strokeWidth={1.8} />}
      Log Out
    </button>
  );
}
